import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { LoadTable } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";

const AllData = gql`
  query {
    DriverAccounts {
      Name
      Residential_City
      Aadhar_Number
      Mobile_Number
      Land_Line
      Notes
      Pan_Number
      Police_Station
      Residential_Address
      Residential_Address_2
      Residential_Pincode
      Residential_State
      Aadhar_Card
      Pan_Card
      Driving_Licence
      Individual_Photo
      Other_Doc_1
      Other_Doc_2
      createdAt
      updatedAt
      id
    }
  }
`;

const UtilityPage = () => {
  const { loading, error, data } = useQuery(AllData, {
    fetchPolicy: "network-only",
  });
  const [formdata, setformdata] = useState(data ? data.DriverAccounts : []);

  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  useEffect(() => {
    let updateddata =
      data &&
      data.DriverAccounts.map((e) => {
        let obj = { ...e };
        delete obj.__typename;
        return {
          ...obj,
          createdAt: IsoToDateTime(e.createdAt),
          updatedAt: IsoToDateTime(e.updatedAt),
        };
      });

    setformdata(updateddata);
  }, [data, loading]);

  return (
    <div>
      <HeaderDiv title="Pages Data" />
      {!formdata?.length && <LoadTable title="Pages Data" data={formdata} loading={loading} error={error} />}
    </div>
  );
};

export default UtilityPage;
